/**
 * 執筆セッション ID。
 *
 * docs/02-architecture.md §6: アプリ起動（タブ）ごとに 1 つ生成する。
 * サーバーはこの ID が変わったことを「執筆セッションの境界」とみなし、上書き前の
 * ヘッドをリビジョンへ退避する。同一セッション内の連続自動保存は何百回来ても
 * 履歴を増やさない。
 *
 * リロードで新しい ID になるのは仕様どおり（リロードは執筆の区切りとみなす）。
 */

export const SESSION_ID: string = crypto.randomUUID();
